import * as React from 'react';
import { mixins } from '@blend/consumer-components';
import { css, StyleSheet } from 'aphrodite';

import FormDialog from 'login-components/Common/Form/FormDialog/FormDialog';
import AppLayoutContextUpdater from 'login-components/Common/AppLayoutContextUpdater/AppLayoutContextUpdater';
import image from './thankYou.svg';

const styles = StyleSheet.create({
  base: {
    ...mixins.margin(0, 'auto'),
    maxWidth: 470,
  },
  dialogContent: {
    ...mixins.padding(50, 20),
    textAlign: 'center',
  },
  image: {
    height: 100,
  },
  heading: {
    fontSize: 20,
    fontWeight: 500,
    ...mixins.margin(34, 0, 20, 0),
  },
});

export default class extends React.Component {
  render() {
    return (
      <div className={css(styles.base)}>
        <AppLayoutContextUpdater appDocumentTitle="Thank you!" appTitle="" footerConfig={null}>
          <FormDialog>
            <div className={css(styles.dialogContent)}>
              <img src={image} className={css(styles.image)} alt="" />
              <h1 className={css(styles.heading)}>Thank you!</h1>
              <p>We'll be in touch if there is anything else we need.</p>
            </div>
          </FormDialog>
        </AppLayoutContextUpdater>
      </div>
    );
  }
}
